export default __webpack_public_path__ + "static/media/arrowList.59e526e7.svg";